export default {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-llbf9mox.auth0.com',
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'Bjv7O253fRtMt200kS3HLxsqdJ5lzCl9',
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || 'augustus',
};
